/**
 * 首页
 */
export default function HomePage() {
  return (
    <div className="p-8 text-center">
      <p className="text-lg text-muted-foreground">待开发</p>
    </div>
  );
}

